import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-secondary/30" data-testid="main-footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <img 
                src="/images/nexus-lbe-logo-black.png" 
                alt="NEXUS LBE" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Formatted, scalable platform for immersive location-based entertainment experiences.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-sm font-['Lato'] font-semibold mb-3">Solutions</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/ip-owners"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  For IP Owners
                </Link>
              </li>
              <li>
                <Link
                  to="/property-partners"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  For Property Partners
                </Link>
              </li>
              <li>
                <Link
                  to="/investors"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  For Investors
                </Link>
              </li>
              <li>
                <Link
                  to="/product"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Our Platform
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-['Lato'] font-semibold mb-3">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/team"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Team
                </Link>
              </li>
              <li>
                <Link
                  to="/roadmap"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Roadmap
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-['Lato'] font-semibold mb-3">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            2025 NEXUS LBE
          </p>
          <div className="flex gap-6">
            <a
              href="mailto:hello@nexuslbe.com"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              hello@nexuslbe.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
